import { Link } from '@mui/material';
import { useNavigate } from 'react-router';

import Button from '@/components/Buttons/Button';
import GoLogo from '@/components/GoLogo';
import Typography from '@/components/Typography';
import { BaseLayout } from '@/layouts/BaseLayout';
import { CenteredLayout } from '@/layouts/CenteredLayout';

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  return (
    <BaseLayout>
      <CenteredLayout>
        <GoLogo size={64} />
        <Typography
          size={36}
          sx={{ fontWeight: 700, mb: 3, mt: 4 }}
        >
          Welcome to GX Go!
        </Typography>
        <Typography
          size={16}
          sx={{ maxWidth: 374, textAlign: 'center' }}
        >
          Providing the fastest, most accessible and integration-friendly platform for commodity
          pricing data.
        </Typography>
        <Button
          size='large'
          sx={{
            my: 4,
            width: 300,
            fontWeight: 700
          }}
          variant='contained'
          onClick={() => {
            navigate('/markets');
          }}
        >
          Get started
        </Button>
        <Typography>
          Any issues? Drop us a line at{' '}
          <Link
            color='text.primary'
            href='mailto:support@general-index.com'
            target='_top'
          >
            support@general-index.com
          </Link>
        </Typography>
      </CenteredLayout>
    </BaseLayout>
  );
};
export default SubscriptionSuccess;
